/**
 * Main app
 *
 */

"use strict";

import $ from 'jquery';
import 'select2';
import { AmericorForm } from './form.js';

class App {
  static us_states = {
    'AL': 'Alabama',
    'AK': 'Alaska',
    'AZ': 'Arizona',
    'AR': 'Arkansas',
    'CA': 'California',
    'CO': 'Colorado',
    'CT': 'Connecticut',
    'DE': 'Delaware',
    'FL': 'Florida',
    'GA': 'Georgia',
    'HI': 'Hawaii',
    'ID': 'Idaho',
    'IL': 'Illinois',
    'IN': 'Indiana',
    'IA': 'Iowa',
    'KS': 'Kansas',
    'KY': 'Kentucky',
    'LA': 'Louisiana',
    'ME': 'Maine',
    'MD': 'Maryland',
    'MA': 'Massachusetts',
    'MI': 'Michigan',
    'MN': 'Minnesota',
    'MS': 'Mississippi',
    'MO': 'Missouri',
    'MT': 'Montana',
    'NE': 'Nebraska',
    'NV': 'Nevada',
    'NH': 'New Hampshire',
    'NJ': 'New Jersey',
    'NM': 'New Mexico',
    'NY': 'New York',
    'NC': 'North Carolina',
    'ND': 'North Dakota',
    'OH': 'Ohio',
    'OK': 'Oklahoma',
    'OR': 'Oregon',
    'PA': 'Pennsylvania',
    'RI': 'Rhode Island',
    'SC': 'South Carolina',
    'SD': 'South Dakota',
    'TN': 'Tennessee',
    'TX': 'Texas',
    'UT': 'Utah',
    'VT': 'Vermont',
    'VA': 'Virginia',
    'WA': 'Washington',
    'WV': 'West Virginia',
    'WI': 'Wisconsin',
    'WY': 'Wyoming'
  };

  constructor() {
    document.addEventListener('form:init', ( e ) => {
      console.log('form:init', e);
    });

    const form = new AmericorForm();
    
    this.smooth_scroll();
    this.init_select2();

    document.querySelectorAll('form').forEach(form => {
      form.addEventListener('submit', e => {
        const progress = document.getElementById("progress")
        progress?.scrollIntoView();
        
        const loading = form.querySelector('.loading');
        loading?.classList.remove('d-none');
      });
    });
  }

  /**
   * Smooth scrolling
   *
   */
  smooth_scroll() {
    const links = document.querySelectorAll(
      "a[href*=\\#]:not([href=\\#]):not([data-toggle])"
    );

    for (const link of links) {
      link.addEventListener("click", smooth_scroll_handler);
    }

    function smooth_scroll_handler(e) {
      e.preventDefault();

      const href = this.getAttribute("href");
      const offsetTop = document.querySelector(href).offsetTop;

      scroll({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  }

  init_select2()
  {
    // Typeahead for location information by postal code
    $('select.select2[name="zip"]').select2({
      //placeholder: 'Enter Postal Code',
      ajax: {
        url: americor.ajaxurl,
        dataType: 'json',
        method: 'post',
        minimumInputLength: 5,
        data: function (params) {
          return {
            action: 'get_zip_information',
            content: params.term
          }
        },
        processResults: function (data) {
          console.log(data);
          
          if ( data.status || ! data.state ) return;

          // Update state name
          document.getElementById('form-s9-location').innerHTML = App.us_states[data.state];
          document.querySelector('input[name=zip]').value = data.zip;

          return {
            results: [{
              text: data.city + ', ' + data.state + ' ' + data.zip,
              id: data.zip,
            }]
          }
        },
      }
    });
  }
}

const app = new App();